const appInfo = {
    title: 'Talentwave.react'
};
export default appInfo;

